/* Vignettes du menu : chargees seulement quand elles deviennent VISIBLES.

   Mesure du 17/09 : 36 vignettes en 1536 px = 3,29 Mo tires sur chaque page,
   pour un rendu de ~324 px, alors que la plupart des visiteurs n ouvrent jamais
   le menu -- et que meme celui qui l ouvre ne voit que le sous-menu ouvert.
   `loading="lazy"` ne suffisait pas : le navigateur les tirait quand meme.

   On pose la source a l entree dans l ecran (IntersectionObserver), ce qui
   limite le telechargement au SOUS-MENU reellement ouvert. Filet : au premier
   geste sur l entete, on charge ce qui est deja affiche. */
(function () {
  function poser(img) {
    if (!img || !img.dataset.lvSrc) return;
    if (img.dataset.lvSrcset) img.srcset = img.dataset.lvSrcset;
    img.src = img.dataset.lvSrc;
    img.removeAttribute('data-lv-src');
    img.removeAttribute('data-lv-srcset');
  }

  function surveiller() {
    var images = document.querySelectorAll('img[data-lv-src]');
    if (!images.length) return;

    if (!window.IntersectionObserver) {
      images.forEach(poser);
      return;
    }

    var obs = new IntersectionObserver(
      function (entrees) {
        entrees.forEach(function (e) {
          if (!e.isIntersecting) return;
          poser(e.target);
          obs.unobserve(e.target);
        });
      },
      { rootMargin: '200px' }
    );
    images.forEach(function (i) { obs.observe(i); });

    /* filet : un panneau anime peut s ouvrir sans que l observateur ait le
       temps de reagir -- au premier geste sur l entete on pose ce qui est
       deja peint (offsetParent non nul = element affiche). */
    var entete = document.querySelector('header, [class*="header"]') || document;
    ['pointerdown', 'focusin', 'touchstart'].forEach(function (evt) {
      entete.addEventListener(
        evt,
        function () {
          document.querySelectorAll('img[data-lv-src]').forEach(function (i) {
            if (i.offsetParent !== null) poser(i);
          });
        },
        { passive: true }
      );
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', surveiller);
  else surveiller();
})();
